"use client"

import { useEffect, useRef } from "react"
import styled from "styled-components"

const ChartContainer = styled.div`
  width: 100%;
  height: ${(props) => props.height}px;
`

function AdvancedChart({ symbol = "BTCUSDT", height = 500, theme = "dark" }) {
  const containerRef = useRef(null)
  const containerId = `tradingview_${symbol}`

  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://s3.tradingview.com/tv.js"
    script.async = true
    script.onload = () => {
      if (typeof window.TradingView !== "undefined" && containerRef.current) {
        new window.TradingView.widget({
          autosize: true,
          symbol: `BINANCE:${symbol}`,
          interval: "60",
          timezone: "Etc/UTC",
          theme: theme,
          style: "1",
          locale: "en",
          toolbar_bg: "#f1f3f6",
          enable_publishing: false,
          allow_symbol_change: true,
          container_id: containerId,
        })
      }
    }
    document.head.appendChild(script)

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
    }
  }, [symbol, theme, containerId])

  return <ChartContainer id={containerId} ref={containerRef} height={height} />
}

export default AdvancedChart

